import React from 'react';
import { Path, usePageContext } from '../../hooks/contexts/usePageContext';
import { ListingOt } from '../../components/2.0version/listingOt/ListingOt';
import { RubriqueTemplateQuery } from '../../../graphql-types';
import { HeaderIntro } from '../../components/2.0version/headerIntro/HeaderIntro';
import * as styles from './rubriqueContent.module.scss';
import { Breadcrumb } from '../../components/2.0version/breadcrumb/Breadcrumb';
import { SanityFilters } from '../../utils/types';

interface IRubriqueContentProps {
  sanityListingSelection?: RubriqueTemplateQuery['sanityListingSelection'];
}

export const RubriqueContent = ({ sanityListingSelection }: IRubriqueContentProps) => {
  const { lang } = usePageContext();

  const otCodes = sanityListingSelection?.list?.map((itemList) => itemList?.code);

  const sanityFilters = sanityListingSelection?.equipmentServices;

  const rubriquePath: Path = {
    label: sanityListingSelection?._rawTitle,
    url: sanityListingSelection?.slug?.current ?? '',
  };

  return (
    <div className={styles.wrapper}>
      <Breadcrumb />
      <div className={styles.intro}>
        <HeaderIntro
          title={sanityListingSelection?.pageHeader?._rawTitle?.[lang]}
          description={sanityListingSelection?.pageHeader?._rawDescription?.text?.[lang]}
        />
      </div>
      <ListingOt
        otCodes={otCodes}
        sanityFilters={sanityFilters as SanityFilters}
        rubriquePath={rubriquePath}
      />
    </div>
  );
};
